import createTheme from 'src/styles/createTheme';

const defaultTheme = createTheme();

export default defaultTheme;
